import { RangeValue } from '@ui-kit/components/rangePicker';

export default function addRangeToParams(
  params: Record<string, any>,
  range?: RangeValue
) {
  const newParams = { ...params };

  if (range?.[0]) {
    newParams.fy = range[0].year();
    newParams.fm = range[0].month() + 1;
    newParams.fd = range[0].date();
  }

  if (range?.[1]) {
    newParams.ty = range[1].year();
    newParams.tm = range[1].month() + 1;
    newParams.td = range[1].date();
  }

  return newParams;
}
